export var PendingSwapNetworkStatus;
(function (PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
})(PendingSwapNetworkStatus || (PendingSwapNetworkStatus = {}));
export var MessageSeverity;
(function (MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})(MessageSeverity || (MessageSeverity = {}));
